<template>
  <div class="container mt-4" style="max-width: 900px">
    <div class="aguarde-container text-center" v-if="this.btnLoading">
      <div class="spinner-border" role="status"></div>
      <br>
      <span>Aguarde...</span>
    </div>
    <div class="" v-if="!this.btnLoading">
      <form @submit.prevent="incluirAssociado"
        class="d-flex justify-content-between p-2 px-lg-4 flex-column flex-lg-row" style="background-color: #e6e6e6;">
        <div class="d-flex my-2 flex-column">
          <small class="font-weight-bold">CPF</small>
          <input type="text" class="form-control" v-mask="'###.###.###-##'" pattern=".{14}" required
            v-model="qualificacaoPessoa.cpf" />
        </div>
        <div class="d-flex my-2 flex-column">
          <small class="font-weight-bold">Nome</small>
          <input type="text" class="form-control" v-model="qualificacaoPessoa.nome" />
        </div>
        <div class="my-2 text-right d-flex align-self-end align-self-lg-center">
          <button class="btn btn_color_system btn-sm">
            <span class="icone_adicionar">&times;</span>
            <span>adicionar</span>
          </button>
        </div>
      </form>

      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">CPF</th>
            <th scope="col">NOME</th>
            <th scope="col">TIPO</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,
          index) in detailRecorrencia.qualificacaoPessoaDTOList" :key="index">
            <td style="vertical-align: middle; wisth 20px">
              #{{ index + 1 }}
            </td>
            <td style="vertical-align: middle;">{{ item.cpf }}</td>
            <td style="vertical-align: middle;">{{ item.nome }}</td>
            <td style="vertical-align: middle;">{{ item.titular ? 'TITULAR': 'DEPENDENTE' }}</td>
            <td style="vertical-align: middle; text-align: right">
              <button v-if="!item.titular" class="btn" @click="excluirAssociado(item.id)">
                <img style="width: 22px" src="@/assets/images/delete.png" />
              </button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <ul>
        <li>
          Seu plano pode ter até
          {{ detailRecorrencia.quantidadeMaximaAssociados }} pessoas associadas incluindo o titular.
        </li>
        <li>Você pode remover e adicionar novos dependentes.</li>
        <li>Os serviços disponíveis no seu plano, estará disponível para os novos dependente em até 30 dias após a
          inclusão.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "StepAssociados",
  components: {},
  data() {
    return {
      user: this.$store.state.user,
      idPlanoAssinatura: this.$route.params.planoId,
      detailRecorrencia: null,
      qualificacaoPessoa: {},
      btnLoading: false
    };
  },
  created() {

    if (this.idPlanoAssinatura > 0) {
      this.btnLoading = true;
      apiService
        .obterMinhaAssinaturaID(this.idPlanoAssinatura)
        .then(response => {
          this.detailRecorrencia = response;
          this.btnLoading = false;
        });
    }
  },
  methods: {
    excluirAssociado(id) {
      this.btnLoading = true;
      apiService
        .excluirAssociado(this.idPlanoAssinatura, id)
        .then(res => {
          this.btnLoading = false;
          this.detailRecorrencia.qualificacaoPessoaDTOList = res;
        })
        .catch(error => {
          this.btnLoading = false;
          this.$swal(error.response.data.title)
        });
    },
    incluirAssociado() {
      this.btnLoading = true;
      const temp = {
        cpf: this.qualificacaoPessoa.cpf.replace(/[^0-9]/g, ""),
        nome: this.qualificacaoPessoa.nome
      };
      apiService
        .incluirAssociado(this.detailRecorrencia.codigoRecorrencia, temp)
        .then(res => {
          this.btnLoading = false;
          this.detailRecorrencia.qualificacaoPessoaDTOList = res;
        })
        .catch(error => {
          this.btnLoading = false;
          this.$swal(error.response.data.title)
        });
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    }
  }
};
</script>
<style scoped lang="scss">
.icone_adicionar {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 1.2rem;
  font-size: 1.5rem;
  padding: 1px 5px;
  vertical-align: inherit;
  margin: 0 5px 0 0;
  transform: rotate(45deg);
}
</style>
